import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { FormContext } from '../../FormContext';
import { getDateDepend, getMinMaxDate } from '../../utils/utilFunctions';
import InputAddRemove from './InputAddRemove';
import { isFieldSigned, determineIsDisabled } from './utils.js';
import './Input.css';

const Input = ({ field_multiple_primary, field_multiple_id, field_multiple, field_autocomplete, field_type, field_disabled_approver, field_column, field_id, field_label, field_placeholder, field_disabled, field_mandatory, field_value = "", field_date_depend, field_number_max, field_number_min, field_multiple_type, field_date_min, field_date_max }) => {
  const { handleChangeInput, handleAddField, formElements, handleRemoveLastField, formStatus, formPageType, formApprovalIndex, formUserLock, formMultipleType, formChatPerson, formOfficers } = useContext(FormContext);
  const [minDate, setMinDate] = useState(field_date_min || null);
  const [maxDate, setMaxDate] = useState(field_date_max || null);
  
  const [inputValue, setInputValue] = useState(field_value);

  useEffect(() => {
    if (typeof field_date_depend !== 'undefined') {
      const date_depend_arr = field_date_depend.split("/");
      try {
        const date_depend = getDateDepend(formElements, date_depend_arr[0]);
        const minmax_date = getMinMaxDate(date_depend, date_depend_arr[1], date_depend_arr[2], date_depend_arr[3]);
        setMinDate(minmax_date.min_date);
        setMaxDate(moment(minmax_date.max_date).format("YYYY-MM-DD"));
      } catch (error) {
        console.log(error)
      }
    } 
    if(field_date_min && field_date_max) {
      setMinDate(field_date_min);
      setMaxDate(field_date_max);
    }
  }, [formElements, field_date_depend, field_date_min, field_date_max]);

  useEffect(() => {
    setInputValue(field_value);
  }, [field_value]);

  let isSigned = isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type);

  const handleAutoComplete = (event, field_autocomplete) => {
    if (field_autocomplete && field_autocomplete === "User" && event.target.value.length > 2) {
      window[`autocomplete${field_autocomplete}`](event.target.value, field_id);
    }
  };

  const hideTimePicker = (event, field_id, field_type) => {
    if (field_type === 'date' || field_type === 'time') {
      window['hideTimePicker'](field_id);
    }
    handleChangeInput(field_id, event);
  };

  const handleFocus = (field_id, event, field_type) => {
    switch (field_type) {
      case 'date':
        window['triggerDatePicker'](field_id, minDate, maxDate);
        break;
      case 'time':
        window['triggerTimePicker'](field_id);
        break;
      default:
        break;
    }
    handleChangeInput(field_id, event);
  };

  const validateMinMax = (value) => {
    if (!value) return value;

    if (field_type === 'date') {
      const dateValue = moment(value);
      if (minDate && dateValue.isBefore(minDate)) {
        return moment(minDate).format('YYYY-MM-DD');
      }
      if (maxDate && dateValue.isAfter(maxDate)) {
        return moment(maxDate).format('YYYY-MM-DD');
      }
      return value;
    }
  
    if ((field_number_min || field_number_max) && value !== "") {
      const numValue = Number(value);
      if (numValue > field_number_max) {
        return field_number_max;
      } else if (numValue < field_number_min) {
        return field_number_min;
      }
      return value;
    }
    return value;
  };
  
  const isDisabled = determineIsDisabled(
    formUserLock,
    formPageType,
    field_multiple_id,
    isSigned,
    field_id,
    formApprovalIndex,
    field_disabled_approver,
    field_disabled,
    formStatus
  );

  return (
    <div className={`form-group ${field_column ? field_column : 'col-sm-6'}`}>
      <label>{field_label} <font color="red">{field_mandatory === 'yes' ? '*' : ''}</font></label>
      <input
        type={field_type === 'number' ? 'number' : 'text'}
        placeholder={field_placeholder ? field_placeholder : ' '}
        value={validateMinMax(inputValue)}
        disabled={isDisabled}
        onChange={event => {
          const newValue = event.target.value;
          if (field_type === 'date') {
            const date = moment(newValue);
            if (!newValue || ((!minDate || date.isSameOrAfter(minDate)) && (!maxDate || date.isSameOrBefore(maxDate)))) {
              setInputValue(newValue);
              handleChangeInput(field_id, event);
            }
          } else {
            setInputValue(newValue);
            handleChangeInput(field_id, event);
          }
        }}
        onFocus={event => handleFocus(field_id, event, field_type)}
        onKeyUp={(event) => handleAutoComplete(event, field_autocomplete)}
        min={minDate}
        max={maxDate}
        className="form-control form-input force-info"
        id={field_id}
        autoComplete="off"
        data-target-input="nearest"
        data-target={`#${field_id}`}
        data-toggle={field_type === 'time' && "datetimepicker"}
        onBlur={(event) => hideTimePicker(event, field_id, field_type)}
      />
      {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id} field_multiple_type={field_multiple_type} />}
    </div>
  );
};

export default Input;